import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { CategoryContainer } from './container';
import { CategoryV2 } from './v2';

type CategoryVersionProps = {
  id: string;
};

export const CategoryVersion: FC<CategoryVersionProps> = ({ id }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <CategoryV2 id={id} />;
  return <CategoryContainer id={id} />;
};
